import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { appUpdateModal } from '../../atomstore/store';
import {
    openNativeAppStore,
    restoreAppUpdateModalIfNeeded,
} from '../../utils/appUpdate';
import FootpringSvg from '../../assets/splash-nico-hi.png';

const AppUpdateModal = () => {
    const [modal] = useAtom(appUpdateModal);

    useEffect(() => {
        restoreAppUpdateModalIfNeeded();
    }, []);

    if (!modal.visible) return null;

    const handleUpdate = async () => {
        await openNativeAppStore();
    };

    return (
        <div
            className="fixed inset-0 z-[100000] flex items-end md:items-center justify-center bg-black/60 backdrop-blur-sm p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="app-update-title"
        >
            <div className="w-full md:max-w-md bg-white rounded-2xl shadow-xl overflow-hidden animate-[slideUp_0.25s_ease-out] md:animate-[fadeIn_0.25s_ease-out]">
                <div className="flex items-center gap-3 px-5 py-4 border-b">
                    <div className="p-2 rounded-full">
                        <img src={FootpringSvg} className="size-10" alt="Parent Connect" />
                    </div>
                    <h3 id="app-update-title" className="font-semibold text-gray-900 text-lg">
                        Update required
                    </h3>
                </div>

                <div className="px-5 py-4">
                    <p className="text-gray-600 text-base font-medium leading-relaxed">
                        {modal.message}
                    </p>
                    <p className="text-gray-500 text-sm mt-3">
                        Install the latest version from the app store to continue using Parent
                        Connect.
                    </p>
                </div>

                <div className="px-5 py-4">
                    <button
                        type="button"
                        onClick={handleUpdate}
                        className="w-full px-4 py-3 text-sm font-semibold bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 active:scale-[0.98] transition"
                    >
                        Update
                    </button>
                </div>
            </div>

            <style>{`
        @keyframes slideUp {
          from { transform: translateY(40px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
        </div>
    );
};

export default AppUpdateModal;
